import axios from "@providers/axiosProvider";
import * as actions from "./actions";

import {
    APIUpdateSettingsRequest,
    APIGetSettingsResponse,
    Settings,
} from './types';

/** @summary GET /properties/public/settings 建物全体公開設定情報取得 */
export const getPropertyAsync = () => async (dispatch: any) => {
  dispatch(actions.setIsLoading(true));

  await axios
    .get<APIGetSettingsResponse>(`/properties/public/settings`)
    .then((response) => {
      const property = response.data.result;
      const data: Settings = {
        isPublic: property.is_public,
      };
      dispatch(actions.setSettings(data));
    })
    .catch(() => {
      return null;
    });

  dispatch(actions.setIsLoading(false));
};

export const updatePropertyAsync =
  (data: APIUpdateSettingsRequest) => async (dispatch: any) => {
    dispatch(actions.setIsSubmitting(true));

    await axios
      .put(`/properties/public/settings`, data)
      .then(() => {
        dispatch(actions.setIsNavigating(true));
      })
      .catch(() => {});

    dispatch(actions.setIsSubmitting(false));
  };
